import { defineMessages } from 'react-intl';

const translations = {
  properties: {
    location: {
      id: 'properties.location',
      defaultMessage: 'Location',
      description: 'label of the location property',
    },
    purchaseOrderNumbers: {
      id: 'properties.purchaseOrderNumbers',
      defaultMessage: 'Purchase order numbers',
      description: 'label of the purchase order numbers property',
    },
    status: {
      id: 'properties.status',
      defaultMessage: 'Status',
      description: 'label of the status property',
    },
    shippingMethod: {
      id: 'properties.shippingMethod',
      defaultMessage: 'Shipping method',
      description: 'label of the shipping method property',
    },
  },
};

export default defineMessages(translations);
